import * as visualAssets from "./../visualAssets.jsx";

export const outerContainer = 
{
	width:"93%",
	//backgroundColor: "#F98",
	margin:"auto",
	paddingTop:"1em",
	paddingBottom:"0.5em",
	//flexDirection:"row",
}

export const leftColumnContainer =
{
	paddingTop:"1vw",
	display:"inline-block",
	width:"58%",
	//border: "1px solid brown",
	verticalAlign:"top",
	//height:200,
}

export const leftColumnContainerMobile =
{
	paddingTop:"4vw",
	display:"inline-block",
	width:"65%",
	//border: "1px solid brown",
	verticalAlign:"top",
	//height:200,
}
export const rightColumnContainer =
{

	//display:"inline-block",
	margin:"auto",
	//flex:1,
	width:"60%",
	verticalAlign:"top",
}

export const rightColumnOuterContainer =
{
	//border: "1px solid red",
	paddingTop:"1vw",
	display:"inline-block",
	//margin:"auto",
	//flex:1,
	marginLeft:"3%",
	//marginRight:"3%",
	float: "right",
	width:"38%",
	//border: "1px solid yellow",
	verticalAlign:"top",
}

export const rightColumnOuterContainerMobile =
{
	//border: "1px solid red",
	paddingTop:"1vw",
	display:"inline-block",
	//margin:"auto",
	//flex:1,
	marginLeft:"1%",
	marginRight:0,
	width:"33%",
	//border: "1px solid yellow",
	verticalAlign:"top",
}

export const dkfLogo =
{
	margin:"auto",
	width:"60%",
	display:"block",
}

export const soundmapLogo =
{
	margin:"auto",
	width:"35%",
	display:"block",
}

export const vimeoIFrameRight =
{
	margin:"auto",
	display:"block",
	marginTop: "1vw",
	marginBottom: "1vw",
	width:"90%",
}

export const vimeoIFrameLeft=
{
	margin:"auto",
	marginTop: "3%",
	marginBottom: "3%",
	display:"block",
	width:"90%",
}

export const hideStyle =
{
	margin:0,
	height:0,
	width:0,
	display:"none",
}

export const box = {
	 backgroundImage:visualAssets.freameRectURL,
	 backgroundSize: "100% 100%",
	 backgroundRepeat:"no-repeat",
	 margin:"auto",
	 //border: "1px solid black",
	 padding:"1vw",

}

export const mapBoxRight = Object.assign({}, box, {
	//width:"80%", 
	//height:"15", 
	padding:"3vw"})

export const leftColBox = Object.assign({}, box, {
	width:"80%",

});
export const footer =
      {
         
         //position:"absolute",
         //bottom:0,
         height:"8vw",
         maxHeight:100,
         width:"100%",
         //border: "1px solid green",
         backgroundImage:visualAssets.soundmapHeaderHorLinesURL,
         backgroundSize: "contain",
         backgroundRepeat:"no-repeat",
         backgroundPosition:"top",
         
      }


// WEBPACK FOOTER //
// ./js/webpages/webpageStyles.jsx